import {
  LOADING,
  GET_ALL_USERS_DATA,
  GET_USER_DETAILS,
  SUPER_UPDATE_USER_DETAILS,
  DELETE_USERS,
  SEARCH_USERS,
  ADD_NEW_USER,
} from "../types";

const initialState = {
  loading: false,
  clientDetailData: {},
  clientsData: [],
}

function userReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_USERS_DATA:
    case DELETE_USERS:
    case SEARCH_USERS:
      return {
        ...state,
        clientsData: payload,
        loading: false,
      };
    case GET_USER_DETAILS:
      return {
        ...state,
        clientDetailData: payload,
        loading: false,
      };
    case SUPER_UPDATE_USER_DETAILS:
      return {
        ...state,
        clientDetailData: { ...state.clientDetailData, ...payload },
        loading: false,
      };
    case ADD_NEW_USER:
      return {
        ...state,
        clientsData: [...state.clientsData, payload.user]
      }
    default:
      return state;
  }
}

export default userReducer;
